// extracted by mini-css-extract-plugin
export default {"wrapper":"LogsChart_wrapper__fT9LJ","filterWrapper":"LogsChart_filterWrapper__r6Ccq"};